// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tAaQv","modal":"styles_modal__vd2st","title":"styles_title__TxBHI","subtitle":"styles_subtitle__haJga","actions":"styles_actions__GwElY"};